import React, { useState } from 'react'
import { uploadText, uploadImage } from '../utils/apiCalls'
import { parseAndReturn } from '../utils/parseResponse'

const Upload: React.FC<any> = ({ setStatus, setMonSlots, setTueSlots, setWedSlots, setThuSlots, setFriSlots }): JSX.Element => {
  const [text, setText] = useState('')
  const [photo, setPhoto] = useState()
  const [label, setLabel] = useState('No file chosen')

  const onUploadPicture = (e: React.BaseSyntheticEvent): void => {
    if (e.target.files !== null && e.target.files.length !== 0) {
      const size = e.target.files[0].size / 1000 / 1000 // file size in MB
      if (size > 30) {
        alert('File exceeded 30MB')
        e.target.value = ''
        return
      }
      setPhoto(e.target.files[0])
      setLabel(e.target.files[0].name)
    }
  }

  const onParse = (res: any): void => {
    const [monSlots, tueSlots, wedSlots, thuSlots, friSlots] = parseAndReturn(res.slots)
    setMonSlots(monSlots)
    setTueSlots(tueSlots)
    setWedSlots(wedSlots)
    setThuSlots(thuSlots)
    setFriSlots(friSlots)
    setStatus('review')
  }

  const submitImage = (e: React.BaseSyntheticEvent): void => {
    e.preventDefault()
    if (photo === undefined || label === 'No file chosen') {
      alert('Please upload an image first!')
      return
    }
    setStatus('loading')
    uploadImage(photo).then((res) => { onParse(res) }, () => { setStatus('upload') })
  }

  const submitText = (e: React.BaseSyntheticEvent): void => {
    e.preventDefault()
    if (text === '') {
      alert('Please paste the text first!')
      return
    }
    setStatus('loading')
    uploadText(text).then((res) => { onParse(res) }, () => { setStatus('upload') })
  }

  return (
    <div className='upload-wrapper'>
      <h1>Upload Timetable</h1>
      <div className='upload'>
        <div className='upload-text'>
          <ol className='steps'>
            <li>Go to the Time Table tab on VTOP</li>
            <li>Scroll down to see the table with your schedule</li>
            <li>Select the text from <span>Theory</span> in the top left to <span>L94</span> in the bottom right</li>
            <li>Copy all of the selected text</li>
            <li>Paste it below </li>
            <input
              autoFocus
              type='text'
              id='input-text'
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <li>Submit to continue! :)</li>
            <button type='submit' onClick={submitText}>Submit Text</button>
          </ol>
        </div>
        </div>
    </div>
  )
}

export default Upload
